// extracted by mini-css-extract-plugin
export default {"cardWrap":"cardWrap--xpSYy","title":"title--jJ1dm","value":"value--KvUBw","markerAnimationScale":"markerAnimationScale--ep_hv"};